export default __webpack_public_path__ + "static/media/info-icon.f44cf54d.svg";